import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useCustDiagStore } from "../../../contexts/RootStoreProvider";

const WizardHelp = (props: any) => {
  const custDiagStore = useCustDiagStore();

 

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Help</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.helpText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} autoFocus>
          Ok Thanks
        </Button>
      </DialogActions>
    </Dialog>
  );
};

WizardHelp.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.any,
  helpText: PropTypes.any,
};

export default observer(WizardHelp);
